/**
 * Mobile app related state actions and mutations.
 * Note: we don't want to call postMessage directly here.
 * We want to instead set the state and let plugins/components respond and act
 * accordingly with native bridge.
 */
import { LinkType } from 'native_bridge/types'
import { RootState } from 'surface/xstore/types'
import { Post } from 'types'
import { ActionContext, Module } from 'vuex'

interface NativeAppOpenLink {
  url: string
  linkType: LinkType
  target?: '_blank' | '_top' | '_self'
  contentCategory: string
  contentSubcategory: string
}

interface AppState {
  linkToOpen: NativeAppOpenLink | null
  expandedPost: Post | null
}

type NativeActionContext = ActionContext<AppState, RootState>

const NativeApp: Module<AppState, RootState> = {
  namespaced: true,
  state: {
    linkToOpen: null,
    expandedPost: null,
  },
  mutations: {
    NATIVE_APP_OPEN_LINK(state, nativeAppOpenLink: NativeAppOpenLink): void {
      state.linkToOpen = nativeAppOpenLink
    },
    NATIVE_APP_LINK_OPENED(state): void {
      state.linkToOpen = null
    },
    EXPAND_POST(state: AppState, post: Post): void {
      state.expandedPost = post
    },
    UNEXPAND_POST(state: AppState): void {
      state.expandedPost = null
    },
  },
  actions: {
    openLink({ commit }, nativeAppOpenLink: NativeAppOpenLink): void {
      commit('NATIVE_APP_OPEN_LINK', nativeAppOpenLink)
    },
    clearOpenLink({ commit }): void {
      commit('NATIVE_APP_LINK_OPENED')
    },
    hideAllPanelsAndMenus({ dispatch, rootState }): void {
      dispatch('settings/hideSettingsPanel', null, { root: true })
      dispatch('share/resetSharePanel', null, { root: true })
      dispatch('hideRemakePanel', null, { root: true })
      dispatch('hideConvertLayoutPanel', null, { root: true })
      dispatch('postAction/endPostCopy', null, { root: true })
      dispatch('postAction/endPostTransfer', null, { root: true })
      if (rootState.postAction && rootState.postAction.postUnderActionCid) {
        dispatch('postAction/hidePostActionMenu', null, { root: true })
      }
      if (rootState.section && rootState.section.actionMenuSectionId) {
        dispatch('section/hideSectionActionMenu', null, { root: true })
      }
      if (rootState.comment && rootState.comment.actionMenuCommentId) {
        dispatch('comment/hideCommentActionMenu', null, { root: true })
      }
    },
    expandPost({ commit }: NativeActionContext, post: Post): void {
      commit('EXPAND_POST', post)
    },
    unexpandPost({ commit }: NativeActionContext): void {
      commit('UNEXPAND_POST')
    },
  },
}

export default NativeApp
